<!-- 图文信息展示列表：模块头+图片+标题 -->
<template>
<div class="content-block">
  <div class="info-list-title">
    <span>{{title}}</span>
    <label>{{label}}</label>
    <a href="#">更多</a>
  </div>
  <div class="info-list-content">
    <ul>
      <li v-for="news in newsList">
        <a href="#" v-bind:style='{backgroundImage:news.imgUrl}'>
          <label>{{news.title}}</label>
          <span>{{news.label}}</span>
        </a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: 'InfoList01',
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '3'
    },
    count: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      newsList:[]
    }
  },
  created:function(){
    this.newsList=this.Global.newsListDemo.slice(0,this.count);
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 0px 0px 2px 0px;
  padding:4px;
  height:78px;
  text-align:left;
}

li img{
  display:block;
  float:left;
  height:80px;
  padding-right:5px;
}

li label{
  display:block;
  font-size:14px;
  font-weight:600;
  color:#282A2B;
  line-height:30px;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}

li span{
  display:block;
  font-size:12px;
  color:#9FA2A6;
  line-height:20px;
}

li a{
  display:block;
  padding:0px 0px 0px 124px;
  background-color: #fff;
  background-size: 120px auto;
  background-repeat: no-repeat;
  background-position: 0px 0px;
}

li a label:hover{
  color:var(--color6);
}

a {
  color: #42b983;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/block/InfoList01.vue